import { motion, AnimatePresence } from 'framer-motion';
import { ExitIcon } from '../svgs/ExitIcon';

type LogoutConfirmModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function LogoutConfirmModal({ isOpen, onConfirm, onCancel }: LogoutConfirmModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onCancel}
            className="absolute inset-0 bg-black/40 backdrop-blur-md"
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="relative w-full max-w-sm bg-white/90 backdrop-blur-xl rounded-[2.5rem] p-8 shadow-2xl border border-white/50 text-center overflow-hidden font-samim"
          >
            <div className="flex justify-center items-center w-16 h-16 mx-auto mb-6 rounded-full bg-red-50">
              <ExitIcon color="#ef4444" />
            </div>

            <h2 className="text-2xl font-samim-bold text-[#375c7d] leading-tight mb-3">
              تسجيل الخروج
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">
              هل أنت متأكد أنك تريد تسجيل الخروج؟
            </p>

            <div className="flex gap-3">
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.95 }}
                onClick={onCancel}
                className="flex-1 bg-gray-100 text-gray-700 font-samim-bold py-3 rounded-2xl text-base transition-colors hover:bg-gray-200"
              >
                إلغاء
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.95 }}
                onClick={onConfirm}
                className="flex-1 bg-red-500 text-white font-samim-bold py-3 rounded-2xl text-base shadow-lg transition-shadow hover:shadow-red-500/40"
              >
                تسجيل الخروج
              </motion.button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
